import { USER_AUTH } from "./../actions/actionTypes";

const initState = {};

export default (state = initState, action) => {
  switch (action.type) {
    case USER_AUTH:
      return action.payload;
    default:
      return state;
  }
};
